import { Base, Collection } from 'active-resource';
import { PriceResource } from 'util/resources/Price';
import APILibrary, { ClassExtender, GConstructor, GenerateResource } from './APILibrary';
import { PlanBenefitResource } from './PlanBenefit';

/**
 * Relationship classes
 */
export class PlanAttributes {
  id: string = null;
  name: string = null;
  trialPeriodDays: number = null;
  activeJobListingLimit: number = null;
  creditCardRequiredForTrial: boolean = null;
}

export class PlanBelongsTo {
  planBenefit: () => PlanBenefitResource = () => new PlanBenefitResource();
}

export class PlanHasOne {}

export class PlanHasMany {
  prices: () => Collection<PriceResource> = () => new Collection<PriceResource>();
}

/**
 * Utility interfaces
 */
export interface PlanMethods {}

export interface PlanInterface extends PlanAttributes, PlanBelongsTo, PlanHasMany, PlanType {}

type PlanType = GConstructor<PlanInterface>;

export interface PlanResource extends Base<PlanAttributes>, PlanInterface, PlanMethods {}

/**
 * Resource methods
 */
const BaseClass = () =>
  GenerateResource<PlanAttributes>({
    queryName: 'employers/plans',
    className: 'Plan',
    AttributesClass: PlanAttributes,
    BelongsToClasses: [
      {
        Klass: PlanBelongsTo,
      },
    ],
    HasManyClasses: [
      {
        Klass: PlanHasMany,
      },
    ],
  });

export const PlanResourceClass = <TBase extends PlanType>(BaseConstructor: TBase): TBase =>
  class extends BaseConstructor implements PlanMethods {};

export class PlanResource extends ClassExtender<PlanInterface>(BaseClass, PlanResourceClass) {}

/**
 * Resource instance
 */
export const Plan = APILibrary.createResource<PlanResource>(PlanResource);
